import React from "react";
import { useParams } from "react-router-dom";

import CategoryPage from "components/pages/ActivityDiscipline/Category";

const Category = () => {
  const { id } = useParams();

  return <CategoryPage id={id} />;
};

export default Category;
